<div class="cb-objectives-form">
  <!-- Header Section -->
  <div class="header-section">
    <label class="subtitle-label">Infinite Goal</label>
    <p class="goal-text">{{ goal() }}</p>
  </div>

  <!-- Objectives List -->
  <div class="objectives-list">
    @for (option of options(); track option.uid) {
      <cb-checkbox-option
        [option]="option"
        [inputValue]="objectives()[option.inputIndex!]?.name ?? ''"
        [hasError]="duplicateInputIndices().has(option.inputIndex!)"
        [removable]="hasMultipleObjectives()"
        (valueChange)="onOptionToggle(option, $event)"
        (inputChange)="onInputChange($event, option.inputIndex ?? 0)"
        (remove)="onRemove(option.inputIndex!)"
      ></cb-checkbox-option>
    }
  </div>
</div>
